var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',_vm._b({attrs:{"loading":_vm.loading || _vm.$attrs.loading},on:{"click":_vm.PictureFlow}},'Button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }